module.exports = " <main class=c-main role=main> <section class=c-main__section> <header> <h2 class=\"c-main__heading u-gutter\">Getting started</h2> </header> <router-view></router-view> </section> <app-footer></app-footer> </main> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-docs/app/pages/HomePage.vue
 ** module id = 253
 ** module chunks = 2
 **/